'use client'

import { createRedirectIntent } from '@/feature/navigation/services/navigation.intents'
import { toEventLinkHref } from '@/feature/product-list/services/productList.routing'
import type { AnyTracking } from '@/lib/tracking/services/tracking.eventTypes'
import { interpolateUrlPlaceholders } from '@/lib/utils/url-placeholders'
import { Link } from '@/ui/links/link/Link.client'

type MarketingEventLinkProps = {
  link: string
  linkTitle?: string
  openInNewTab: boolean
  children: React.ReactNode
  customerEmail?: string
  webshopReference?: string
  trackingData?: AnyTracking
}

export function MarketingEventLink({
  link,
  linkTitle,
  openInNewTab,
  children,
  customerEmail,
  webshopReference,
  trackingData,
}: MarketingEventLinkProps) {
  const target = toEventLinkHref(
    interpolateUrlPlaceholders(link, { customerEmail, webshopReference }),
  )

  return (
    <Link
      variant="free"
      underlined="none"
      className="mx-auto block w-fit"
      href={target}
      title={linkTitle || undefined}
      opensInNewTab={!!openInNewTab}
      trackingData={trackingData}
      intent={createRedirectIntent({
        to: target,
      })}
    >
      {children}
    </Link>
  )
}
